import { colors } from 'kangarootime-ui';

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: `0px solid ${colors.grayChateau}`,
    backgroundColor: '#F4F5F7',
    height: '40px',
    opacity: state.isDisabled ? 0.5 : 1
  }),
  menu: provided => ({
    ...provided,
    boxShadow: '0 8px 16px 0 rgba(169, 194, 209, 0.25)',
    borderStyle: 'solid',
    borderColor: '#F4F5F7',
    borderWidth: '1px',
    backgroundColor: colors.white
  }),
  placeholder: provided => ({
    ...provided,
    color: colors.charade
  }),
  input: provided => ({
    ...provided,
    color: colors.charade
  }),
  singleValue: provided => ({
    ...provided,
    color: colors.charade,
    fontSize: '1rem',
    fontWeight: 400,
    fontFamily: 'proxima-soft, sans-serif'
  }),
  multiValue: provided => ({
    ...provided,
    backgroundColor: colors.disabled
  }),
  multiValueRemove: provided => ({
    ...provided,
    ':hover': {
      backgroundColor: colors.brand_1_hover,
      color: 'white'
    }
  })
};

export const customTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: colors.brand_1,
    primary25: colors.athensGray,
    primary50: colors.athensGray
  }
});
